import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PersonalDataService } from '../personal-data.service';
import { UtilitiesService } from '../../../../common/shared/services/utilities.service';
import { DialogService } from '../../../../common/shared/services/dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { Contact } from '../../../../common/models/contact';
import { PreferredContactMethodEnum, PrimaryContactLanguageEnum, OccupationEnum } from '../../../../common/helper/enums';
import { TypeofExpr } from '@angular/compiler';
import { CountryService } from '../../../../common/shared/services/country.service';

@Component({
  selector: 'app-personal-data-form',
  templateUrl: './personal-data-form.component.html',
  styleUrls: ['./personal-data-form.component.scss']
})
export class PersonalDataFormComponent implements OnInit {

  countries = this.countryService.countryList;
  contact: Contact;
  area: string;
  selected: string;
  countryInput: string;

  PreferredContactMethodEnum: typeof PreferredContactMethodEnum = PreferredContactMethodEnum;
  PrimaryContactLanguageEnum: typeof PrimaryContactLanguageEnum = PrimaryContactLanguageEnum;
  OccupationEnum: typeof OccupationEnum = OccupationEnum;

  constructor(
    @Inject(MAT_DIALOG_DATA) public input: any,
    private _dialogRef: MatDialogRef<PersonalDataFormComponent>,
    private _personalDataService: PersonalDataService,
    private countryService: CountryService,
    public utilitiesService: UtilitiesService) { }

  ngOnInit() {
    this.contact = new Contact();
    if (this.input !== null) {
      this.area = this.input.area;
      // Creating new instance/do a deep copy to not sync data between View and Edit.
      this.contact = JSON.parse(JSON.stringify(this.input.contact));
      this.selected = this.contact.addressCountry;
    }
  }

  update(newCountryValue) {
    this.contact.addressCountry = newCountryValue;
    this.utilitiesService.addMinorAction('UpdatePersonalData');
    this._personalDataService.updateContact(this.contact).subscribe(
      data => {
        this.utilitiesService.removeAction('UpdatePersonalData');
        if (this.utilitiesService.getData(data)) {
          this._dialogRef.close('Success');
        } else {
          this._dialogRef.close('Error');
        }
      },
      err => {
        this.utilitiesService.handleErrors(err);
        this._dialogRef.close('Close');
      }
    );
  }

  updateActionActive() {
    return this.utilitiesService.isActionActive('UpdatePersonalData');
  }

  foreignPersonnummerValueChange(newValue) {
    this.contact.personnummer = '';
  }
}



